import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Editable } from "@/components/builder/Editable";

const FAQS = [
  { key: "q1", q: "Da dove raccoglie le comunicazioni Sedio?", a: "Da email, PEC e WhatsApp: tutto arriva in un unico posto. L'AI legge anche gli allegati (PDF, Excel, immagini), li riassume e li classifica." },
  { key: "q2", q: "L'AI agisce da sola?", a: "No. L'AI prepara le bozze, apre le pratiche e propone i fornitori, ma le decisioni restano tue: approvi e condividi solo cio che vuoi." },
  { key: "q3", q: "Come funziona il Programma Partner Sedio?", a: "Il compenso è riservato ai Partner Sedio. Trovi tutte le condizioni chiare nella piattaforma: accedi gratis e provalo, senza chiamate e senza impegno." },
  { key: "q4", q: "Posso importare i miei condomini e le anagrafiche?", a: "Sì. Importi condomini e anagrafiche da qualsiasi gestionale: l'intelligenza artificiale riconosce e struttura automaticamente i dati per te." },
  { key: "q5", q: "I condomini hanno un accesso dedicato?", a: "Si, tramite i Portali Condomini condividi documenti e raccogli segnalazioni con un accesso sicuro e dedicato." },
  { key: "q6", q: "Come gestite privacy e dati?", a: "Trattiamo i dati nel rispetto della normativa vigente e li usiamo solo per fornirti il servizio. I tuoi dati restano tuoi." },
];

export const FAQ = () => {
  const cols = [FAQS.slice(0, 3), FAQS.slice(3)];
  return (
    <section id="faq" data-testid="faq" className="bg-white">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Editable as="p" path="faq.eyebrow" className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-primary">Domande? Risposte</Editable>
        <Editable as="h2" path="faq.title" className="block max-w-2xl font-display text-4xl font-extrabold text-foreground sm:text-5xl">Tutto quello che vuoi sapere.</Editable>
        <div className="mt-10 grid gap-x-10 md:grid-cols-2">
          {cols.map((col, ci) => (
            <Accordion key={ci} type="single" collapsible className="w-full">
              {col.map((f) => (
                <AccordionItem key={f.key} value={f.key} data-testid={`faq-item-${f.key}`}>
                  <AccordionTrigger className="text-left text-base font-semibold text-foreground"><Editable path={`faq.${f.key}.q`}>{f.q}</Editable></AccordionTrigger>
                  <AccordionContent className="text-sm leading-6 text-muted-foreground"><Editable path={`faq.${f.key}.a`}>{f.a}</Editable></AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  );
};
